// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const StatusContainer = styled.div`
  padding: 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.375rem 1.75rem;
  };
`;

export const IndicatorsContainer = styled.div`
  flex-direction: column;
  display: flex;
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  border-radius: 4px;
  width: 100%;
`;
